import request from "@/config/serve.js";

// 查询
export function getAccountDetailList(params) {
  return request("post", "/apiGo/api/v1/settlement/list", params);
}
//开发者充值管理-审核查询
export function getAccountDetail(data) {
  return request("get", "/developerAccount/getAccountDetail", data);
}
//开发者充值管理-充值审核
export function auditRecharge(data) {
  return request("post", "/developerAccount/auditRecharge", data);
}
//获取满足激励政策
export function getRechargeGive(data) {
  return request("get", "/developerAccount/getLaunch", data);
}
// 获取投放者名称
export function getDeveloperUserList(params) {
  return request("get", "/apiGo/api/v1/developerUser/list", params);
}
// 获取应用列表
export function getAppList(params) {
  return request("post", "/apiGo/api/v1/app/appList", params);
}
// 新增
export function insertPriceThreshold(data) {
  return request("post", "/apiGo/api/v1/settlement/add", data);
}
// 修改
export function editPriceThreshold(data) {
  return request("post", "/apiGo/api/v1/settlement/update", data);
}
